import styles from './Heading.module.scss';
import React from 'react';
import { useAlgoliaAppContext } from '../../../hooks/useAlgoliaAppContext';
import { MEDIA_BREAKPOINTS } from '../../../../constants/MEDIA_BREAKPOINTS';
export const HeadingTitleSkeleton = () => {
    const { pagePath } = useAlgoliaAppContext();
    const isCollection = pagePath === 'collections';
    return (React.createElement("div", { className: "d:flex ai:start" },
        isCollection &&
            React.createElement("div", { className: `skeleton bdrs:2 ${styles.image}` }),
        React.createElement("div", null,
            React.createElement("div", { className: `skeleton bdrs:2 ${styles.h1Title}`, style: { height: '0.73em', width: '4em', marginBottom: '0.28em' } }),
            isCollection &&
                React.createElement("div", { className: `skeleton bdrs:2 ${styles.h1Subtitle}`, style: { height: '1.16em', width: '7.5em', border: 'none' } }))));
};
export const HeadingDescriptionSkeleton = () => (React.createElement("div", { className: styles.description, style: { transform: 'translateY(0.2em)' } },
    React.createElement("span", { className: "skeleton bdrs:2 d:inline-block", style: { height: '1em', width: '85%' } }),
    React.createElement("span", { className: "skeleton bdrs:2 d:inline-block", style: { height: '1em', width: '95%' } }),
    MEDIA_BREAKPOINTS.XL_UP.matches &&
        React.createElement("span", { className: "skeleton bdrs:2 d:inline-block", style: { height: '1em', width: '55%' } })));
export const HeadingSkeleton = () => {
    const { pagePath } = useAlgoliaAppContext();
    return (React.createElement("div", { className: `d:grid ${styles.wrapper}` },
        React.createElement(HeadingTitleSkeleton, null),
        pagePath !== 'search' &&
            React.createElement("div", null,
                React.createElement(HeadingDescriptionSkeleton, null))));
};
